import { InputBase } from "@mui/material";
import { alpha, styled } from "@mui/material/styles";
import { useContext } from "react";
import { UserContext } from "../../../../../../App";

const StyledInput = ({ value, onChange, placeholder, ...props }) => {
  const { color } = useContext(UserContext);
  const BootstrapInput = styled(InputBase)(({ theme }) => ({
    "label + &": {
      marginTop: theme.spacing(3),
    },
    "& .MuiInputBase-input": {
      borderRadius: 4,
      position: "relative",
      //   backgroundColor: theme.palette.mode === "light" ? "#F3F6F9" : "#1A2027",
      backgroundColor: color === "dark" ? "#182a40" : "#F3F6F9",
      color: color === "dark" ? "white" : "black",
      border: "1px solid",
      borderColor: theme.palette.mode === "light" ? "#E0E3E7" : "#2D3843",
      fontSize: 16,
      width: "100%",
      padding: "10px 12px",
      transition: theme.transitions.create(["border-color", "background-color", "box-shadow"]),
      // Use the system font instead of the default Roboto font.
      fontFamily: [
        "-apple-system",
        "BlinkMacSystemFont",
        '"Segoe UI"',
        "Roboto",
        '"Helvetica Neue"',
        "Arial",
        "sans-serif",
        '"Apple Color Emoji"',
        '"Segoe UI Emoji"',
        '"Segoe UI Symbol"',
      ].join(","),
      "&:focus": {
        boxShadow: `${alpha(theme.palette.primary.main, 0.25)} 0 0 0 0.2rem`,
        borderColor: theme.palette.primary.main,
      },
    },
  }));

  return <BootstrapInput value={value} onChange={onChange} placeholder={placeholder} {...props} />;
};

export default StyledInput;
